import axios from "axios";

export default function Login(){
    
    function submitHandler(e){   
        e.preventDefault();
        const obj = new FormData(e.target);
        const data = Object.fromEntries(obj.entries()); 
        axios.post(`${process.env.REACT_APP_BASE_URL}api/user/open/userLogin`,data)
        .then(result=>{
         localStorage.setItem("username",result.data.username);
         localStorage.setItem("auth-token",result.data.token);
         localStorage.setItem("role",result.data.role);
         window.location.href="/dashboard";
        })
        .catch(err => {
            if (err.response) {
            alert(err.response.data);
            } else if (err.request) {
            alert("Server is unreachable. Please try again later.");
            } else {
            alert("An unexpected error occurred: " + err.message);
            }
        });
    }

    localStorage.clear();
    return (
        <div className="login-container container">
            <div className="text-center">
                <h2>Quiz Login!</h2>
                <hr />
            </div>
            <br />
            <div className="form">
                <form onSubmit={submitHandler}>
                    <div>
                        <label htmlFor="username">Email/Mobile:</label>
                        <input className="form-control" type="text" name="username" required />
                    </div>
                    <div>
                        <label htmlFor="password">Password:</label>
                        <input className="form-control" type="password" name="password" required />
                    </div><br />
                    <div>
                        <button className="btn btn-color form-control" type="submit">Login</button>
                    </div>
                    <br />
                    <div className="text-center">
                        <a href="/" className="text-decoration-none text-muted">
                        &larr; Return to Home
                        </a>
                    </div>
                </form>
            </div>
        </div>
    );
}